export function useScrollDirection() {
  const scrollDirection = ref('none')
  onMounted(() => {
    window.addEventListener('scroll', onScroll)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
  })

  let position: number

  if (import.meta.client) {
    position = window.scrollY
  }

  function onScroll() {
    const scroll = window.scrollY
    if (scroll < position) {
      scrollDirection.value = 'up'
    } else {
      scrollDirection.value = 'down'
    }
    position = scroll
  }

  return {
    scrollDirection,
  }
}
